import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/cn';

interface TickerTagProps {
  ticker: string;
  assetType?: 'stock' | 'coin';
  price?: number;
  changePct?: number;
  className?: string;
}

export function TickerTag({ ticker, assetType = 'stock', changePct, className }: TickerTagProps) {
  const navigate = useNavigate();
  const color =
    changePct === undefined
      ? ''
      : changePct > 0
      ? 'text-[var(--color-rise)]'
      : changePct < 0
      ? 'text-[var(--color-fall)]'
      : '';

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/ticker/${ticker}`);
      }}
      className={cn(
        'inline-flex items-center gap-1 rounded-md border border-[var(--color-border)] bg-[var(--color-surface)] px-2 py-0.5 text-xs font-medium',
        'hover:border-[var(--color-primary)]/40 hover:bg-[var(--color-primary)]/5 transition-colors',
        color,
        className,
      )}
    >
      <span className="text-[var(--color-text-sub)]">{assetType === 'coin' ? '🪙' : '📈'}</span>
      <span>{ticker}</span>
      {changePct !== undefined && (
        <span className="tabular-nums">
          {changePct > 0 ? '+' : ''}
          {changePct.toFixed(2)}%
        </span>
      )}
    </button>
  );
}
